(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- toast ---------- */
  var tt;
  function toast(msg) {
    var t = $("#toastr"); if (!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("on"); }, 3000);
  }

  /* ---------- money ---------- */
  var FORMAT = (window.Shopify && window.Shopify.money_format) || "${{amount}}";
  function money(cents) {
    var v = cents / 100;
    var s = (v % 1 === 0) ? v.toFixed(2) : v.toFixed(2);
    return FORMAT.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  /* ---------- mobile nav ---------- */
  var burger = $("#burger"), mnav = $("#mnav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", String(open));
    });
  }

  /* ---------- cart count ---------- */
  function setCount(n) { $$("[data-cart-count]").forEach(function (el) { el.textContent = String(n); }); }
  function refreshCount() {
    if (!window.fetch) return;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- bundle builder ---------- */
  var tierBtns = $$("[data-tier]");
  var rows     = $$("[data-product]");
  if (rows.length) {
    var elTier  = $("[data-sum-tier]");
    var elItems = $("[data-sum-items]");
    var elDisc  = $("[data-sum-disc]");
    var elTotal = $("[data-sum-total]");
    var elAdd   = $("[data-add]");
    var rate = 0, tierLabel = "", tierCode = "";
    // without pouch tiers the box mirrors the store's automatic quantity discounts:
    // 2 eligible items → qty_2 %, 3 or more → qty_3 % (the cart applies the real discount)
    var picker = $("[data-picker]");
    var qty2 = picker ? (parseFloat(picker.dataset.disc2) || 0) : 0;
    var qty3 = picker ? (parseFloat(picker.dataset.disc3) || 0) : 0;

    if (tierBtns.length) {
      var first = tierBtns[0];
      rate = parseFloat(first.dataset.rate) || 0;
      tierLabel = first.dataset.label || "";
      tierCode = first.dataset.code || "";
    }

    function render() {
      var items = 0, subtotal = 0, elig = 0, eligSub = 0;
      rows.forEach(function (row) {
        var q = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
        items += q;
        var line = q * (parseInt(row.dataset.cents, 10) || 0);
        subtotal += line;
        if (row.dataset.disc !== "0") { elig += q; eligSub += line; }
      });
      var pct = 0, off = 0;
      if (tierBtns.length) {
        pct = Math.round(rate * 100);
        off = Math.round(subtotal * rate);
      } else {
        pct = elig >= 3 ? qty3 : elig === 2 ? qty2 : 0;
        off = Math.round(eligSub * pct / 100);
      }
      var total = subtotal - off;
      if (elTier)  elTier.textContent  = tierLabel;
      if (elItems) elItems.textContent = String(items);
      if (elDisc)  elDisc.textContent  = off ? "−" + pct + "% (" + money(off) + ")" : "—";
      if (elTotal) elTotal.textContent = money(total);
      if (elAdd) {
        elAdd.disabled = items === 0;
        elAdd.textContent = items === 0
          ? "Add at least 1 item"
          : "Add " + items + " item" + (items === 1 ? "" : "s") + " — " + money(total);
      }
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        tierBtns.forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
        rate = parseFloat(btn.dataset.rate) || 0;
        tierLabel = btn.dataset.label || "";
        tierCode = btn.dataset.code || "";
        render();
      });
    });

    rows.forEach(function (row) {
      var out = row.querySelector("[data-qty]");
      var inc = row.querySelector("[data-inc]");
      var dec = row.querySelector("[data-dec]");
      if (inc) inc.addEventListener("click", function () {
        out.textContent = String(Math.min(20, (parseInt(out.textContent, 10) || 0) + 1)); render();
      });
      if (dec) dec.addEventListener("click", function () {
        out.textContent = String(Math.max(0, (parseInt(out.textContent, 10) || 0) - 1)); render();
      });
    });

    if (elAdd) elAdd.addEventListener("click", function () {
      var payload = [];
      var missing = false;
      rows.forEach(function (row) {
        var q = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
        if (!q) return;
        var id = row.dataset.variant;
        if (!id) { missing = true; return; }
        payload.push({ id: Number(id), quantity: q });
      });
      if (missing && !payload.length) {
        toast("Connect these rows to products in the theme editor first");
        return;
      }
      if (!payload.length) return;
      var label = elAdd.textContent;
      elAdd.disabled = true; elAdd.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: payload })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          refreshCount();
          if (missing) toast("Added. Some rows have no product connected yet.");
          if (tierCode) {
            window.location.href = "/discount/" + encodeURIComponent(tierCode) + "?redirect=/cart";
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function () {
          toast("Could not add that — try again");
          elAdd.disabled = false; elAdd.textContent = label;
        });
    });

    render();
  }

  /* ---------- "while you ___" rotator ---------- */
  var rot = $("[data-rotate]");
  if (rot && !reduce) {
    var words = $$(".whileyou__list span").map(function (n) { return n.textContent.trim(); });
    if (words.length > 1) {
      var i = 0;
      rot.style.transition = "opacity .22s ease";
      setInterval(function () {
        i = (i + 1) % words.length;
        rot.style.opacity = "0";
        setTimeout(function () { rot.textContent = words[i]; rot.style.opacity = "1"; }, 220);
      }, 2600);
    }
  }

  /* ---------- FAQ: one open at a time ---------- */
  var qs = $$(".q");
  qs.forEach(function (q) {
    q.addEventListener("toggle", function () {
      if (!q.open) return;
      var grp = q.closest(".faq, [data-world-item], .pdpx");   // one open per group (each product world keeps its own)
      qs.forEach(function (o) { if (o !== q && (!grp || grp.contains(o))) o.open = false; });
    });
  });

  /* ---------- product page ---------- */
  $$("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var main = $("#pdpMain");
      if (main) {
        main.src = btn.dataset.thumb;
        if (btn.dataset.thumbSrcset) main.srcset = btn.dataset.thumbSrcset; else main.removeAttribute("srcset");
      }
      $$("[data-thumb]").forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
    });
  });

  var qtyOut = $("[data-pdp-qty]"), qtyInput = $("[data-pdp-qty-input]");
  function setQty(n) {
    n = Math.max(1, n);
    if (qtyOut) qtyOut.textContent = String(n);
    if (qtyInput) qtyInput.value = String(n);
  }
  var pInc = $("[data-pdp-inc]"), pDec = $("[data-pdp-dec]");
  if (pInc) pInc.addEventListener("click", function () { setQty((parseInt(qtyOut.textContent, 10) || 1) + 1); });
  if (pDec) pDec.addEventListener("click", function () { setQty((parseInt(qtyOut.textContent, 10) || 1) - 1); });

  var vjson = $("[data-variants]");
  if (vjson) {
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (e) {}
    var groups = $$("[data-option-group]");
    var selects = $$("[data-option-selector]");
    var idField = $("[data-variant-id]"), priceEl = $("[data-price]"), addBtn = $("[data-add]");
    function chosenValues() {
      if (groups.length) {
        return groups.map(function (g) {
          var sel = g.querySelector("select");
          if (sel) return sel.value;
          var r = g.querySelector("input[type=radio]:checked");
          return r ? r.value : "";
        });
      }
      return selects.map(function (s) { return s.value; });
    }
    function update() {
      var chosen = chosenValues();
      var match = variants.filter(function (v) {
        return chosen.every(function (val, idx) { return v.options[idx] === val; });
      })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.addLabel || "Add to cart") : "Sold out";
      }
      try { document.dispatchEvent(new CustomEvent("ig:variant", { detail: { id: match.id, price: match.price, available: match.available } })); } catch (err) {}
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }
    }
    groups.forEach(function (g) { g.addEventListener("change", update); });
    selects.forEach(function (s) { s.addEventListener("change", update); });
    if (groups.length || selects.length) update();
  }

  var pform = $("#ProductForm");
  if (pform && window.fetch) {
    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = pform.querySelector("[data-add]");
      var label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(pform) })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function (item) {
          refreshCount();
          if (pform.dataset.after === "cart") { window.location.href = "/cart"; return; }
          var cfg = {}; try { cfg = JSON.parse((document.querySelector("[data-buy-config]") || {}).textContent || "{}"); } catch (e) {}
          toast(cfg.added || ((item.product_title || "Item") + " added to cart"));
        })
        .catch(function () { toast("Could not add that — try again"); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }
})();

/* ============================================================
   GLOWPOP v4 — nutrition panel tabs, reviews
   (the cursor is now pure CSS — see theme.css "the cursor")
   ============================================================ */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- nutrition facts: one panel per product ---------- */
  $$("[data-nfx]").forEach(function (root) {
    var tabs   = $$("[data-nfx-tab]", root);
    var panels = $$("[data-nfx-panel]", root);
    if (tabs.length < 2) return;

    function show(key, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.nfxTab === key;
        t.setAttribute("aria-selected", String(on));
        t.setAttribute("tabindex", on ? "0" : "-1");
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.dataset.nfxPanel !== key; });
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () { show(t.dataset.nfxTab, false); });
      t.addEventListener("keydown", function (e) {
        var i = tabs.indexOf(t), n = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") n = tabs[(i + 1) % tabs.length];
        if (e.key === "ArrowLeft"  || e.key === "ArrowUp")   n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === "Home") n = tabs[0];
        if (e.key === "End")  n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); show(n.dataset.nfxTab, true); }
      });
    });

    // start on the tab the page marked as selected (a product page pre-selects its own label)
    var pre = tabs.filter(function (t) { return t.getAttribute("aria-selected") === "true"; })[0] || tabs[0];
    show(pre.dataset.nfxTab, false);
  });

  /* ---------- reviews: show more / fewer (event delegation so it works after the editor re-renders) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-rev-more]") : null;
    if (!btn) return;
    var sec = btn.closest("[data-rev-world]") || btn.closest(".rev"); if (!sec) return;
    var more = $$(".rcard--more", sec);
    var open = btn.getAttribute("aria-expanded") === "true";
    more.forEach(function (c) { c.hidden = open; });
    if (!btn.dataset.more) btn.dataset.more = btn.textContent;
    btn.textContent = open ? btn.dataset.more : (btn.dataset.less || "Show fewer");
    btn.setAttribute("aria-expanded", String(!open));
    if (open && more[0]) { var top = sec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: top, behavior: "smooth" }); }
  });
})();

/* ============================================================
   GLOWPOP v4.15 — product worlds (the switcher and its dock),
   the buy box, the Supplement Facts drawer, swipe dots
   ============================================================ */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- money ---------- */
  var FORMAT = (window.Shopify && window.Shopify.money_format) || "${{amount}}";
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return FORMAT.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, "");
  }

  /* ---------- product worlds ---------- */
  var WORLDS = (window.IG_WORLDS || []).filter(function (w) { return w.on; });
  function worldDef(key) { for (var i = 0; i < WORLDS.length; i++) if (WORLDS[i].key === key) return WORLDS[i]; return null; }

  function paintWorld(key) {
    var d = worldDef(key); if (!d) return;
    root.setAttribute("data-world", key);
    root.setAttribute("data-world-color", d.color);
    $$("[data-world-pick]").forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.worldPick === key)); });
    $$("[data-world-name]").forEach(function (el) { el.textContent = d.name; });
    $$("[data-world-link]").forEach(function (a) { if (d.url) { a.href = d.url; a.hidden = false; } else { a.hidden = true; } });
    // sections that have nothing for this world fold away; the label follows the world's product
    $$("[data-world-zone]").forEach(function (z) {
      var items = $$("[data-world-item]", z);
      if (items.length) {
        var has = items.some(function (it) { return it.dataset.worldItem === key; });
        z.classList.toggle("is-world-empty", !has);
      }
    });
    $$("[data-nfx-follow]").forEach(function (sec) {
      var panels = $$("[data-nfx-panel]", sec);
      var hit = panels.filter(function (p) { return (p.dataset.products || "").split(",").indexOf(d.handle) >= 0; })[0];
      panels.forEach(function (p) { p.hidden = p !== hit; });
      sec.classList.toggle("is-world-empty", !hit);
    });
    try { sessionStorage.setItem("ig-world", key); } catch (e) {}
  }

  var switching = null;
  function setWorld(key, opts) {
    opts = opts || {};
    if (root.hasAttribute("data-world-locked")) return;
    if (!worldDef(key) || key === root.getAttribute("data-world")) { paintWorld(key); return; }
    var zones = $$("[data-world-zone]");
    if (reduce || opts.instant) { paintWorld(key); return; }
    clearTimeout(switching);
    zones.forEach(function (z) { z.classList.add("is-switching"); });
    switching = setTimeout(function () {
      paintWorld(key);
      requestAnimationFrame(function () { zones.forEach(function (z) { z.classList.remove("is-switching"); }); });
    }, 200);
  }
  window.IG = window.IG || {};
  window.IG.setWorld = setWorld;

  // first paint: the head script chose the world; now sync the pickers and the label
  if (root.getAttribute("data-world")) paintWorld(root.getAttribute("data-world"));

  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-world-pick]") : null;
    if (!b) return;
    e.preventDefault();
    setWorld(b.dataset.worldPick);
    var rail = b.closest("[data-world-rail]");
    if (!rail) return;
  });

  /* the dock appears once the switcher has scrolled away and stays while the story sections are on screen */
  var dock = $("[data-world-dock]"), rail = $("[data-world-rail]");
  if (dock && rail) {
    var ticking = false;
    function place() {
      ticking = false;
      var zones = $$("[data-world-zone]").filter(function (z) { return !z.classList.contains("is-world-empty") && z.offsetParent !== null; });
      if (!zones.length) { dock.hidden = true; return; }
      var last = zones[zones.length - 1];
      var railBottom = rail.getBoundingClientRect().bottom + window.pageYOffset;
      var zoneEnd = last.getBoundingClientRect().bottom + window.pageYOffset;
      var y = window.pageYOffset, vh = window.innerHeight;
      var show = (y + 80 > railBottom) && (y + vh * 0.6 < zoneEnd);
      dock.hidden = !show;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    setTimeout(place, 300);
  }

  /* ---------- the buy box: 1 / 2 / 3, one-time or subscribe ---------- */
  var buy = $("[data-buy]");
  if (buy) {
    var form = buy.closest("form");
    var qtyInput = $("[data-pdp-qty-input]", form);
    var planInput = $("[data-plan-input]", form);
    var addBtn = $("[data-add]", form);
    var cfg = {};
    try { cfg = JSON.parse(($("[data-buy-config]") || {}).textContent || "{}"); } catch (e) {}

    function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
    function state() {
      var q = num((form.querySelector("[data-tier-input]:checked") || {}).value, 1);
      var pt = (form.querySelector("[data-ptype-input]:checked") || {}).value || "once";
      return { q: q, sub: pt === "sub" };
    }
    function calc() {
      var st = state();
      var base = num(buy.dataset.base, 0), t2 = num(buy.dataset.t2, 0), t3 = num(buy.dataset.t3, 0), subPct = num(buy.dataset.sub, 0);
      var unitS = buy.dataset.unitS || "pouch", unitP = buy.dataset.unitP || unitS + "s";
      var saveWord = buy.dataset.saveWord || "Save", eachWord = buy.dataset.eachWord || "each";
      var sub = st.sub ? subPct : 0;
      function priceFor(q) {
        var tier = q === 2 ? t2 : q === 3 ? t3 : 0;
        var unitSub = Math.round(base * (1 - sub / 100));     // the plan's price, per unit
        var line = unitSub * q;
        var disc = Math.round(line * tier / 100);              // the quantity discount, on the line
        return { total: line - disc, was: base * q, tier: tier };
      }
      [1, 2, 3].forEach(function (q) {
        var p = priceFor(q);
        var each = $("[data-tier-each=\"" + q + "\"]", buy), save = $("[data-tier-save=\"" + q + "\"]", buy);
        if (each) each.textContent = money(Math.round(p.total / q)) + " " + eachWord;
        if (save) {
          var pct = p.was ? Math.round((1 - p.total / p.was) * 100) : 0;
          save.textContent = pct > 0 ? saveWord + " " + pct + "%" : "";
        }
      });
      var once = $("[data-once-price]", buy), subEl = $("[data-sub-price]", buy);
      if (once) { var s1 = (function () { var keep = sub; sub = 0; var r = priceFor(st.q); sub = keep; return r; })(); once.textContent = money(Math.round(s1.total / st.q)) + " " + eachWord; }
      if (subEl) { var s2 = (function () { var keep = sub; sub = subPct; var r = priceFor(st.q); sub = keep; return r; })(); subEl.textContent = money(Math.round(s2.total / st.q)) + " " + eachWord; }
      var p = priceFor(st.q);
      var lab = $("[data-total-label]", buy), tot = $("[data-total]", buy), was = $("[data-total-was]", buy), line = $("[data-save-line]", buy);
      if (lab) lab.textContent = st.q + " " + (st.q === 1 ? unitS : unitP) + (st.sub ? " · subscription" : "");
      if (tot) tot.textContent = money(p.total);
      if (was) { was.hidden = p.total >= p.was; was.textContent = money(p.was); }
      if (line) { var saved = p.was - p.total; line.hidden = saved <= 0; line.textContent = saved > 0 ? "You " + saveWord.toLowerCase() + " " + money(saved) + (st.sub ? " on every delivery" : " today") : ""; }
      if (qtyInput) qtyInput.value = String(st.q);
      if (planInput) planInput.disabled = !st.sub;
      if (addBtn && !addBtn.disabled) addBtn.textContent = (addBtn.dataset.addLabel || "Add to cart") + " — " + money(p.total);
    }
    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-tier-input],[data-ptype-input]")) calc();
    });
    document.addEventListener("ig:variant", function (e) { buy.dataset.base = String(e.detail.price); calc(); });
    calc();

    // after adding: go to the bag, where the savings show, unless told to stay
    form.addEventListener("submit", function () {
      form.dataset.after = cfg.after || "cart";
    }, true);
  }

  /* ---------- the Supplement Facts drawer ---------- */
  var drawer = $("[data-facts-drawer]");
  var openers = $$("[data-facts-open]");
  if (drawer && !drawer.querySelector("[data-nfx-panel]")) drawer = null;
  if (drawer) {
    openers.forEach(function (b) { b.hidden = false; });
    var lastFocus = null, closing = null;
    function openDrawer() {
      clearTimeout(closing);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add("has-drawer");
      setTimeout(function () { drawer.classList.add("is-open"); }, 30);
      setTimeout(function () { var p = $(".fdrawer__panel", drawer); if (p) p.focus({ preventScroll: true }); }, 120);
    }
    function closeDrawer() {
      drawer.classList.remove("is-open");
      document.body.classList.remove("has-drawer");
      closing = setTimeout(function () { drawer.hidden = true; }, 480);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("[data-facts-open]")) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest && e.target.closest("[data-facts-close]")) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !drawer.hidden) closeDrawer(); });
  } else {
    openers.forEach(function (b) { b.hidden = true; });
  }

  /* ---------- swipe rows: little dots that follow the scroll on phones ---------- */
  $$("[data-swipe]").forEach(function (row) {
    var dots = row.parentElement && row.parentElement.querySelector("[data-swipe-dots]");
    if (!dots) return;
    var kids = Array.prototype.slice.call(row.children);
    if (kids.length < 2) return;
    dots.innerHTML = kids.map(function () { return "<span></span>"; }).join("");
    var ds = $$("span", dots);
    function mark() {
      var x = row.scrollLeft + row.clientWidth / 2, best = 0, bd = Infinity;
      kids.forEach(function (k, i) { var c = k.offsetLeft + k.offsetWidth / 2, d = Math.abs(c - x); if (d < bd) { bd = d; best = i; } });
      ds.forEach(function (d, i) { d.classList.toggle("is-on", i === best); });
    }
    row.addEventListener("scroll", function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
  });
})();
